// import React from "react";


export default function Contact(){
    return (
        <h1>Contact me</h1>
    )

}